module.exports = __webpack_public_path__ + "img/Trolley.8f835626.png";